import * as React from 'react';

const Profile: React.FC = () => {
    return (
		<svg focusable="false" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z" fill="currentColor"/>
			<path fillRule="evenodd" clipRule="evenodd" d="M24 25.25C28.8325 25.25 32.75 29.1675 32.75 34L32.7435 34.1278C32.6795 34.7581 32.1472 35.25 31.5 35.25H16.5C15.8096 35.25 15.25 34.6904 15.25 34L15.2537 33.742C15.3902 29.0288 19.2538 25.25 24 25.25ZM24 12.75C26.7614 12.75 29 14.9886 29 17.75C29 20.5114 26.7614 22.75 24 22.75L23.7831 22.7454C21.1223 22.6318 19 20.4388 19 17.75L19.0046 17.5331C19.1182 14.8723 21.3112 12.75 24 12.75Z" fill="white"/>
		</svg>
	);
};

export default React.memo(Profile);
